import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { modulesService } from '../api/modules.service';

export function useModulesRegistryQuery() {
  return useQuery({
    queryKey: queryKeys.modules.registry(),
    queryFn: () => modulesService.list(),
    staleTime: 60_000,
  });
}
